// Simple English verb patterns (common verb endings and helper verbs)
const ENGLISH_HELPER_VERBS = new Set([
  'is', 'are', 'was', 'were', 'be', 'been', 'being',
  'have', 'has', 'had', 'having',
  'do', 'does', 'did', 'doing', 'done',
  'will', 'would', 'shall', 'should',
  'can', 'could', 'may', 'might', 'must',
  'go', 'get', 'got', 'make', 'run', 'set', 'put', 'say', 'said',
  'see', 'saw', 'know', 'knew', 'take', 'took', 'give', 'gave',
  'find', 'found', 'tell', 'told', 'come', 'came', 'think', 'thought',
  'look', 'want', 'use', 'try', 'ask', 'need', 'keep', 'let', 'start',
  'show', 'hear', 'play', 'move', 'live', 'believe', 'happen', 'provide',
  'create', 'build', 'write', 'read', 'learn', 'change', 'follow', 'stop',
  'send', 'receive', 'buy', 'sell', 'open', 'close', 'add', 'remove',
  'check', 'test', 'manage', 'update', 'delete', 'save', 'load', 'share',
]);

const ENGLISH_VERB_ENDINGS = [
  /ing$/,   // running, making
  /ed$/,    // created, updated
  /ize$/,   // optimize, customize
  /ise$/,   // organise, realise
  /ate$/,   // create, generate
  /ify$/,   // modify, simplify
  /ute$/,   // execute, distribute
];

// Greek verb endings for imperatives and common conjugations
const GREEK_VERB_PATTERNS = [
  // Imperative endings (singular)
  /ε$/,    // κάνε, γράψε, στείλε
  /α$/,    // διάβασα, έγραψα
  /σε$/,   // διάβασε, έγραψε
  // Present tense endings
  /ω$/,    // κάνω, γράφω
  /εις$/,  // κάνεις, γράφεις
  /ει$/,   // κάνει, γράφει
  /ουμε$/,  // κάνουμε
  /ετε$/,  // κάνετε
  /ουν$/,  // κάνουν
  // Past tense
  /ησα$/,  // έκανησα
  /ησες$/,
  /ησε$/,
  // Infinitive-like forms
  /σει$/,  // να κάνει, να γράψει
  /ψει$/,
  /ξει$/,
];

// Check if text contains Greek characters
function containsGreek(text: string): boolean {
  return /[\u0370-\u03FF\u1F00-\u1FFF]/.test(text);
}

// Check Greek text for verbs using pattern matching
function containsGreekVerb(text: string): boolean {
  const words = text.toLowerCase().split(/\s+/);
  
  for (const word of words) {
    if (word.length < 2) continue;
    for (const pattern of GREEK_VERB_PATTERNS) {
      if (pattern.test(word)) {
        return true;
      }
    }
  }
  
  return false;
}

// Check English text for verbs using word lists and patterns
function containsEnglishVerb(text: string): boolean {
  const words = text.toLowerCase().replace(/[^a-z\s]/g, '').split(/\s+/);
  
  for (const word of words) {
    if (word.length < 2) continue;
    if (ENGLISH_HELPER_VERBS.has(word)) return true;
    for (const pattern of ENGLISH_VERB_ENDINGS) {
      if (word.length > 4 && pattern.test(word)) return true;
    }
  }
  
  return false;
}

/**
 * Checks if the given text contains at least one verb
 * Uses pattern-based detection for both English and Greek
 */
export function containsVerb(text: string): boolean {
  if (!text || text.trim().length === 0) {
    return false;
  }
  
  if (containsGreek(text)) {
    return containsGreekVerb(text);
  }
  
  return containsEnglishVerb(text);
}
